module.exports = __webpack_public_path__ + "img/9cc8385.jpg";